import { api } from "./apiConfig";

export const getDashboardStats = async () => {
  // Calculate date ranges in client's local time
  const now = new Date();

  // Start of today at 00:00:00 local time
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  // End of today at 23:59:59.999 local time
  const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);

  // Start of current week (Monday) at 00:00:00 local time
  const dayOfWeek = now.getDay();
  const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
  const weekStart = new Date(now.getFullYear(), now.getMonth(), now.getDate() + mondayOffset);

  // End of current week (Sunday) at 23:59:59.999 local time
  const weekEnd = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + 6, 23, 59, 59, 999);

  // Start of current month at 00:00:00 local time
  const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);

  // End of current month at 23:59:59.999 local time (last day of month)
  const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);

  const { data } = await api.get("/dashboard/stats", {
    params: {
      todayStart: todayStart.toISOString(),
      todayEnd: todayEnd.toISOString(),
      weekStart: weekStart.toISOString(),
      weekEnd: weekEnd.toISOString(),
      monthStart: monthStart.toISOString(),
      monthEnd: monthEnd.toISOString()
    }
  });
  return data;
};
